import {Model} from "@/app/Model";

export class FamigliaAdmin {
    public listaFamiglia: Array<Partial<ItemFamiglia>> = [];
    public itemFamiglia: ItemFamiglia = new ItemFamiglia();
    public filtriFamiglia: FiltriFamiglia = new FiltriFamiglia();

    public paginazioneFamiglia_tot: number = 0;
    public paginazioneFamiglia_start: number = 0; //numero di pagina
    public paginazioneFamiglia_rows: number = Model.pagination_size;
    public paginazioneFamiglia_pages: number = 0;

    static sort_fields: string[] = [
        "data_elaborazione",
        "id_doc_master",
        "id_localita",
        "durata_procedimento",
        "data",
        "oggetto_di_giudizio",
        "addebito",
        "tipologia_procedimento",
        "riferimento_normativo",
        "motivi_addebito_separazione",
        "regime_mantenimento",
        "regime_affidamento",
        "assegnazione_casa_familiare",
        "regime_collocamento",
        "valore_assegno_mantenimento",
        "valore_assegno_contributo_mantenimento",
        "valore_assegno_divorzile",
        "giudice",
        "modifica_manuale"
    ]
}

export class ItemFamiglia {
    public raw?: ItemFamiglia;
    public id_doc_master: number = 0;
    public giudice: string[] = [];
    public data_elaborazione?: string; // "2024-10-09T07:12:23.361Z";
    public modifica_manuale?: boolean;
    public data?: string; //"2018-12-04T23:00:00.000Z";
    public id_localita?: string;
    public durata_procedimento?: number;
    public riferimento_normativo: string[] = [];
    public motivi_addebito_separazione: string[] = [];
    public tipologia_procedimento?: string;
    public oggetto_di_giudizio?: string;
    public regime_mantenimento?: string;
    public regime_affidamento?: string;
    public assegnazione_casa_familiare?: string;
    public regime_collocamento?: string;
    public valore_assegno_mantenimento?: number;
    public valore_assegno_contributo_mantenimento?: number;
    public valore_assegno_divorzile?: number;
    public addebito?: boolean;
}

export class FiltriFamiglia {
    public id_doc_master: string = ""; // -> number  =
    public modifica_manuale: string = ""; // -> boolean
    public oggetto_di_giudizio: string = ""; //=

    public sort_field: string = "data_elaborazione";
    public sort_order: string = "DESC";
}
